import { handleResponse, getBaseUrlPortal } from "./apiUtils";

const baseUrl = getBaseUrlPortal(); //"https://localhost:44354/api/";

// NOTE: unlike the other *NewApi clients, this call must NEVER reject.
// Schools that are not (yet) present in the new backend will 404 here,
// and that is expected/normal: the legacy flat promo flow must keep
// working silently in that case. So we swallow every failure (network
// error, 404, any non-OK status) and resolve to null instead of
// rethrowing (handleError from apiUtils rethrows, so it is not used here).
export function getPromozioniScuola(codiceScuola) {
  return fetch(`${baseUrl}scuole/${codiceScuola}/promozioni`, {
    headers: {
      "X-SK-ApiKey": "ca89dd70-63cb-4e8e-af44-bc22062563cf", // Replace with your actual API key
    },
  })
    .then(handleResponse)
    .catch(() => null);
}
